/** Inline Stripe wordmark, sized to match the surrounding text cap-height. */
export function StripeMark({ className = "" }) {
  return (
    <img
      src="/partners/stripe.png"
      alt="Stripe"
      draggable="false"
      className={`inline-block h-[1.5em] w-auto select-none align-[-0.42em] ${className}`}
    />
  );
}

/** Renders a string, replacing every literal "Stripe" with the inline wordmark. */
export function withStripe(text) {
  if (typeof text !== "string" || !text.includes("Stripe")) return text;
  const parts = text.split("Stripe");
  return parts.flatMap((part, i) =>
    i < parts.length - 1
      ? [part, <StripeMark key={`s-${i}`} />]
      : [part]
  );
}
